import { render, staticRenderFns } from "./About_FAQ.vue?vue&type=template&id=6f363128&scoped=true"
import script from "./About_FAQ.vue?vue&type=script&lang=js"
export * from "./About_FAQ.vue?vue&type=script&lang=js"
import style0 from "./About_FAQ.vue?vue&type=style&index=0&id=6f363128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f363128",
  null
  
)

export default component.exports